import { useEffect } from "react";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { useLenis } from "@/providers/LenisProvider";
import { scrollToElement, scrollToTop } from "@/lib/smooth-scroll";

/**
 * Globalna obsługa linków kotwicznych (`<a href="#sekcja">`).
 * Dzięki delegacji zdarzeń każdy taki link na stronie przewija płynnie
 * do sekcji (lub na górę dla `href="#"`), aktualizując adres w pasku URL.
 *
 * Przy preferencji "ogranicz ruch" przewijanie jest natychmiastowe.
 */
export function SmoothAnchors() {
  const reducedMotion = usePrefersReducedMotion();
  const lenis = useLenis();

  useEffect(() => {
    function onClick(event: MouseEvent) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

      const anchor = (event.target as HTMLElement | null)?.closest?.("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href || !href.startsWith("#")) return;
      if (anchor.target && anchor.target !== "_self") return;

      const id = decodeURIComponent(href.slice(1));

      if (!id) {
        event.preventDefault();
        scrollToTop({ lenis, reducedMotion });
        history.pushState(null, "", window.location.pathname + window.location.search);
        return;
      }

      const target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();
      scrollToElement(target, { lenis, reducedMotion });
      history.pushState(null, "", `#${id}`);
    }

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [lenis, reducedMotion]);

  return null;
}

export default SmoothAnchors;
